// A0 — Platforma modullari (kill-switch) + DB modellar ko'ruvchi (read-only).
// Module-local data layer, REAL endpoints (deployed LIVE):
//   GET  /admin/modules                     — 8 feature-modul + holat (admin)
//   POST /admin/modules/:key/toggle         — yoqish/o'chirish (SUPERADMIN, audited)
//   GET  /admin/db/tables                   — public-schema jadval ro'yxati (SUPERADMIN)
//   GET  /admin/db/tables/:table?limit&offset — qatorlar, maxfiy ustunlar '***' (SUPERADMIN, read-only)
// Server superadmin/gating'ni O'ZI majburlaydi (403 → <PermissionDenied>).
// HOT fayllarga tegmaydi; ro'yxatga olish (nav/route) = ./REGISTER.md.
import { api } from '@/lib/api'

export interface PlatformModule {
  key: string
  title: string
  enabled: boolean
}
export interface DbTable {
  table: string
  rows_estimate: number
}
export interface DbRows {
  table: string
  columns: string[]
  rows: Record<string, string | null>[]
}

/** GET /admin/modules → 8 platforma feature-moduli + yoqilgan holati. */
export function fetchModules(signal?: AbortSignal): Promise<PlatformModule[]> {
  return api
    .get<{ modules: PlatformModule[] }>('/admin/modules', signal ? { signal } : undefined)
    .then((d) => d.modules ?? [])
}

/** POST /admin/modules/:key/toggle {enabled} → kill-switch (superadmin, audited). */
export function toggleModule(key: string, enabled: boolean): Promise<{ key: string; enabled: boolean }> {
  return api.post<{ key: string; enabled: boolean }>(`/admin/modules/${key}/toggle`, { enabled })
}

/** GET /admin/db/tables → jadval ro'yxati + qator-taxmini. */
export function fetchTables(signal?: AbortSignal): Promise<DbTable[]> {
  return api
    .get<{ tables: DbTable[] }>('/admin/db/tables', signal ? { signal } : undefined)
    .then((d) => d.tables ?? [])
}

/** GET /admin/db/tables/:table → qatorlar (read-only, maxfiy ustun maskalangan). */
export function fetchRows(
  table: string,
  limit: number,
  offset: number,
  signal?: AbortSignal,
): Promise<DbRows> {
  return api.get<DbRows>(`/admin/db/tables/${encodeURIComponent(table)}`, {
    query: { limit, offset },
    ...(signal ? { signal } : {}),
  })
}

export const PLAT_STR = {
  // modul kill-switch
  modules: 'Модули платформы',
  modulesDesc: 'Включение/выключение функций платформы (kill-switch, только суперадмин)',
  on: 'Вкл',
  off: 'Выкл',
  toggled: 'Статус модуля изменён',
  toggleFailed: 'Не удалось изменить статус',
  // DB browser
  db: 'Модели (БД)',
  dbDesc: 'Просмотр таблиц БД — только чтение, секретные столбцы скрыты',
  tables: 'Таблицы',
  rows: 'строк',
  readonly: 'Только чтение · секретные столбцы замаскированы (***)',
  selectTable: 'Выберите таблицу слева',
  prev: 'Назад',
  next: 'Вперёд',
  empty: 'Нет данных',
  loadFailed: 'Ошибка загрузки',
} as const
